var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h4", {
              staticClass: "title mt-4",
              domProps: {
                textContent: _vm._s(
                  _vm.$t(
                    "apeironGwApp.coordinadoresSnp.mensajes.tituloRegistro"
                  )
                ),
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.readOnly
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("buscador-persona", {
                    on: { selected: _vm.seleccionarCoordinador },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.personaSinCorreo
        ? _c(
            "b-row",
            { staticClass: "mensaje" },
            [
              _c("b-col", { staticClass: "mt-4" }, [
                _c("strong", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.coordinadoresSnp.coordinadorSinCorreo.titulo"
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("span", {
                  staticClass: "m-0 p-0",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.coordinadoresSnp.coordinadorSinCorreo.explicacion"
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "m-0 p-0",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.coordinadoresSnp.coordinadorSinCorreo.solucion"
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                _c("a", {
                  attrs: {
                    href: String(_vm.$t("global.urlRizoma")),
                    target: "_blank",
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      String(
                        _vm.$t("apeironGwApp.persona.participacion.404.sitio")
                      )
                    ),
                  },
                }),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.nombreCompleto"
                      ) + " *",
                    "label-for": "input-nombre-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-nombre-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.nombreCompleto"
                      ),
                      disabled: "",
                    },
                    model: {
                      value: _vm.coordinador.nombre,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "nombre", $$v)
                      },
                      expression: "coordinador.nombre",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.nombre?.required
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.required"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t("apeironGwApp.coordinadoresSnp.form.usuario") +
                      " *",
                    "label-for": "input-usuario-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-usuario-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.usuario"
                      ),
                      disabled: "",
                    },
                    model: {
                      value: _vm.coordinador.usuario,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "usuario", $$v)
                      },
                      expression: "coordinador.usuario",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.usuario?.required
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.required"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t("apeironGwApp.coordinadoresSnp.form.cvu") + " *",
                    "label-for": "input-cvu-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-cvu-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.cvu"
                      ),
                      disabled: "",
                    },
                    model: {
                      value: _vm.coordinador.cvu,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "cvu", $$v)
                      },
                      expression: "coordinador.cvu",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.cvu?.required
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.required"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t("apeironGwApp.coordinadoresSnp.form.correo") +
                      " *",
                    "label-for": "input-correo-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-correo-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.correo"
                      ),
                      disabled: "",
                    },
                    model: {
                      value: _vm.coordinador.correo,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "correo", $$v)
                      },
                      expression: "coordinador.correo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.correo?.required
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.required"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm.$t(
                      "apeironGwApp.coordinadoresSnp.form.telefono"
                    ),
                    "label-for": "input-telefono-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-telefono-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.telefono"
                      ),
                      disabled: _vm.readOnly,
                    },
                    model: {
                      value: _vm.coordinador.telefono,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "telefono", $$v)
                      },
                      expression: "coordinador.telefono",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.telefono?.TELEFONO_VALIDO
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(
                      _vm._s(_vm.$t("entity.validation.telefonoInvalido"))
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label:
                      _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.correoInstitucional"
                      ) + " *",
                    "label-for": "input-correo-institucional-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-correo-institucional-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.correoInstitucional"
                      ),
                      disabled: _vm.readOnly,
                    },
                    model: {
                      value: _vm.coordinador.correoInstitucional,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "correoInstitucional", $$v)
                      },
                      expression: "coordinador.correoInstitucional",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.correoInstitucional?.required
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.required"))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.$v.coordinador.correoInstitucional?.CORREO
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.correoInvalido"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-2",
                  attrs: {
                    label: _vm.$t(
                      "apeironGwApp.coordinadoresSnp.form.correoAlterno"
                    ),
                    "label-for": "input-correo-alterno-coordinador",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-correo-alterno-coordinador",
                      placeholder: _vm.$t(
                        "apeironGwApp.coordinadoresSnp.form.correoAlterno"
                      ),
                      disabled: _vm.readOnly,
                    },
                    model: {
                      value: _vm.coordinador.correoAlterno,
                      callback: function ($$v) {
                        _vm.$set(_vm.coordinador, "correoAlterno", $$v)
                      },
                      expression: "coordinador.correoAlterno",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$v.coordinador.correoAlterno?.CORREO
                ? _c("small", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.$t("entity.validation.correoInvalido"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card-text",
        { staticStyle: { "text-align": "end" } },
        [
          !_vm.readOnly
            ? _c(
                "b-button",
                {
                  staticClass: "mt-3",
                  attrs: { variant: "primary", disabled: _vm.$v.$invalid },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "apeironGwApp.coordinadoresSnp.acciones.asociarCoordinador"
                        )
                      ),
                    },
                  }),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }